import { EMAIL_PATTERN, isEmailDomainAllowed } from '@psyomics/ui-common';
import { isValidPhoneNumber, type CountryCode } from 'libphonenumber-js';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useValidateEmailOrPhone = (countryCode: CountryCode = 'GB', allowedEmailDomains?: string[]) => {
  const { t } = useTranslation();
  const validate = useCallback(
    (value: string) => {
      if (EMAIL_PATTERN.test(value)) {
        return isEmailDomainAllowed(value, allowedEmailDomains ?? []) || t('auth.common.errors.emailDomainNotAllowed');
      }

      return isValidPhoneNumber(value, countryCode) || t('auth.common.errors.usernameInvalid');
    },
    [t, countryCode, allowedEmailDomains]
  );
  return validate;
};

export { useValidateEmailOrPhone };
